import { createGlobalStyle } from 'styled-components';

export const SierraGlobalStyles = createGlobalStyle`
:root {
  --bg: #f6f4ee;
  --bg-2: #efede1;
  --dark: #0d0c14;
  --dark-2: #13121c;
  --ink: #1a1915;
  --ink2: #1a1915;
  --grad-start: #e91e8c;
  --grad-mid: #c4207a;
  --grad-end: #6b2fa0;
  --gradient: linear-gradient(135deg, #e91e8c 0%, #c4207a 40%, #6b2fa0 100%);
  --gradient-dark: linear-gradient(135deg, #ff5bb7 0%, #e91e8c 50%, #d02e8f 100%);
  --gradient-text: linear-gradient(135deg, #e91e8c, #c4207a, #6b2fa0);
  --border: rgba(26, 25, 21, 0.08);
  --border-d: rgba(255, 255, 255, 0.1);
  --serif: "Fraunces", "Georgia", serif;
  --heading: "Fraunces", "Georgia", serif;
  --sans: "Inter", sans-serif;
  --body-d: #f0ede5;
}
*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html {
  scroll-behavior: smooth;
  overscroll-behavior-x: none;
}
body {
  font-family: var(--sans);
  background: var(--bg);
  color: var(--ink);
  -webkit-font-smoothing: antialiased;
  overflow-x: hidden;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: var(--heading) !important;
  font-weight: 500;
  text-wrap: balance;
  letter-spacing: -0.005em;
  margin: 0;
}
p {
  font-family: var(--sans);
}
b, strong {
  font-family: var(--sans);
}
a {
  text-decoration: none;
  color: inherit;
}
::selection {
  background: rgba(233, 30, 140, 0.12);
}
.mega-rail-title {
  color: var(--grad-start);
}
.w {
  max-width: 1320px;
  margin: 0 auto;
  padding: 0 clamp(20px, 4vw, 80px);
}
.scroll-line {
  position: fixed;
  top: 0;
  left: 0;
  height: 2px;
  background: var(--gradient);
  z-index: 9999;
  width: 0%;
  transition:width .08s linear
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: var(--sans);
  font-size: 15px;
  font-weight: 500;
  padding: 14px 28px;
  border-radius: 8px;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  cursor: pointer;
  border: none;
  text-decoration: none;
}
.btn--grad {
  background: var(--gradient);
  color: #fff;
}
.btn--grad:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(233, 30, 140, 0.25);
  filter: brightness(1.05);
}
.btn--outline-white {
  background: transparent;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.35);
}
.btn--outline-white:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.6);
}
.btn--outline-dark {
  background: transparent;
  color: var(--ink);
  border: 1px solid rgba(26, 25, 21, 0.25);
}
.btn--outline-dark:hover {
  border-color: var(--ink);
  background: rgba(26, 25, 21, 0.04);
}
.btn .ar {
  transition: transform 0.2s;
}
.btn:hover .ar {
  transform: translateX(3px);
}
h1 em,
h2 em,
h3 em {
  font-style: italic;
  font-weight: 600;
  background: none;
  -webkit-text-fill-color: inherit;
  -webkit-background-clip: initial;
  background-clip: initial;
  color: inherit;
  text-decoration: underline;
  text-decoration-color: var(--pink);
  text-decoration-thickness: 2px;
  text-underline-offset: 0.14em;
}
.sp-hero {
  background: var(--dark);
  min-height: 100vh;
  display: flex;
  align-items: center;
  padding: 80px 0 80px;
  position: relative;
  overflow: hidden;
}

.sp-hero-video {
  position: absolute;
  inset: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(0.5) saturate(1.15);
  pointer-events: none;
}

.sp-hero::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 1;
  background:
    linear-gradient(
      180deg,
      rgba(13, 12, 20, 0.55) 0%,
      rgba(13, 12, 20, 0.22) 40%,
      rgba(13, 12, 20, 0.5) 100%
    ),
    linear-gradient(90deg, rgba(13, 12, 20, 0.4) 0%, rgba(13, 12, 20, 0) 50%);
  pointer-events: none;
}

.sp-hero::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 1;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.025) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.025) 1px, transparent 1px);
  background-size: 64px 64px;
  pointer-events: none;
  mask-image: radial-gradient(ellipse 90% 90% at 50% 50%, #000 30%, transparent 100%);
  opacity: 0.6;
}
.sp-hero > .w {
  position: relative;
  z-index: 2;
}
.sp-hero-inner {
  position: relative;
  z-index: 2;
  max-width: 900px;
  width: 100%;
}
.sp-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-family: var(--sans);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #e91e8c;
  margin-bottom: 24px;
}
.sp-eyebrow-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #e91e8c;
  flex-shrink: 0;
}

.sp-lockup {
  display: inline-flex;
  align-items: center;
  gap: 22px;
  margin-bottom: 40px;
  padding: 14px 26px;
  border: 1px solid rgba(233, 30, 140, 0.32);
  border-radius: 14px;
  background: rgba(233, 30, 140, 0.06);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.sp-lockup-logo {
  display: inline-flex;
  align-items: center;
}
.sp-lockup-logo--ibex svg {
  height: 32px;
  width: auto;
  display: block;
  color: #fff;
}
.sp-lockup-logo--ibex svg .ibex-dot-fill {
  fill: #ff00e6;
}
.sp-lockup-logo--sierra svg {
  height: 34px;
  width: auto;
  display: block;
}
.sp-lockup-divider {
  width: 1px;
  height: 30px;
  background: rgba(255, 255, 255, 0.2);
}

.nowrap {
  white-space: nowrap;
}

.sp-hero h1 {
  font-family: var(--heading) !important;
  font-size: clamp(40px, 4.9vw, 72px);
  font-weight: 500;
  line-height: 1.05;
  letter-spacing: -0.025em;
  color: #fff;
  margin-bottom: 28px;
  max-width: 18ch;
}
.sp-hero h1 em {
  color: #fff !important;
}
.sp-hero-sub {
  font-family: var(--sans);
  font-size: clamp(16px, 1.45vw, 19px);
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.74);
  max-width: 640px;
  margin-bottom: 36px;
}
.sp-hero-sub strong {
  color: #fff;
  font-weight: 600;
}
.sp-hero-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 36px;
}
.sp-pill {
  font-family: var(--sans);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.06em;
  padding: 7px 16px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: rgba(255, 255, 255, 0.78);
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.sp-pill-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #e91e8c;
  flex-shrink: 0;
}
.sp-hero-ctas {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-bottom: 48px;
}

.sp-about-strip {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  padding-top: 32px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  max-width: 880px;
}
.sp-about-strip-col {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.sp-about-strip-tag {
  font-family: var(--sans);
  font-size: 9.5px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #ff88cc;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(233, 30, 140, 0.12);
  width: fit-content;
}
.sp-about-strip-text {
  font-family: var(--sans);
  font-size: 13px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.72);
}
.sp-about-strip-text strong {
  color: #fff;
  font-weight: 600;
}
@media (max-width: 700px) {
  .sp-about-strip {
    grid-template-columns: 1fr;
    gap: 28px;
  }
}

.sp-section-eyebrow {
  font-family: var(--sans);
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #c4207a;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.sp-section-eyebrow::before {
  content: "";
  width: 20px;
  height: 1px;
  background: #c4207a;
}
.sp-section-eyebrow--dark {
  color: #ff88cc;
}
.sp-section-eyebrow--dark::before {
  background: #ff88cc;
}
.sp-why {
  background: var(--bg);
  padding: 100px 0;
}
.sp-why-header {
  max-width: 780px;
  margin: 0 auto 64px;
  text-align: center;
}
.sp-why-header .sp-section-eyebrow {
  justify-content: center;
}
.sp-why-header h2 {
  font-family: var(--heading) !important;
  font-size: clamp(32px, 3.5vw, 50px);
  font-weight: 500;
  line-height: 1.08;
  letter-spacing: -0.02em;
  color: var(--ink);
}
.sp-props-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2px;
  border: 1px solid var(--border);
  border-radius: 16px;
  overflow: hidden;
  background: var(--border);
}
.sp-prop {
  background: var(--bg);
  padding: 40px 36px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  transition: background 0.2s;
}
.sp-prop:hover {
  background: #fff;
}
.sp-prop-num {
  font-family: var(--sans);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.14em;
  color: #c4207a;
}
.sp-prop h3 {
  font-family: var(--heading) !important;
  font-size: clamp(22px, 2vw, 28px);
  font-weight: 500;
  line-height: 1.1;
  letter-spacing: -0.01em;
  color: var(--ink);
}
.sp-prop p {
  font-family: var(--sans);
  font-size: 15px;
  line-height: 1.65;
  color: rgba(26, 25, 21, 0.7);
}
.sp-prop-vs{
  font-family:var(--heading);font-style:italic;font-weight:500;
  font-size:15px;line-height:1.4;color:rgba(26,25,21,.5);
  letter-spacing:-.005em;
}
.sp-prop-rule {
  width: 32px;
  height: 2px;
  background: var(--gradient);
  border-radius: 999px;
}
@media (max-width: 900px) {
  .sp-props-grid {
    grid-template-columns: 1fr;
  }
}
.sp-proof {
  background: var(--dark-2);
  padding: 100px 0;
  position: relative;
  overflow: hidden;
}
.sp-proof::before {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(
    ellipse 50% 70% at 0% 0%,
    rgba(107, 47, 160, 0.1) 0%,
    transparent 70%
  );
  pointer-events: none;
}
.sp-proof-inner {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
  align-items: start;
}
.sp-proof-left h2 {
  font-family: var(--heading) !important;
  font-size: clamp(28px, 3vw, 44px);
  font-weight: 500;
  line-height: 1.1;
  letter-spacing: -0.02em;
  color: #fff;
  margin-bottom: 20px;
  max-width: 14ch;
}
.sp-proof-left p {
  font-family: var(--sans);
  font-size: 15.5px;
  line-height: 1.65;
  color: rgba(255, 255, 255, 0.72);
  margin-bottom: 36px;
  max-width: 48ch;
}
.sp-case-card {
  padding: 32px 36px;
  border: 1px solid rgba(233, 30, 140, 0.18);
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.04) 0%, rgba(233, 30, 140, 0.04) 100%);
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.sp-case-eyebrow {
  font-family: var(--sans);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #ff88cc;
  display: flex;
  align-items: center;
  gap: 8px;
}
.sp-case-eyebrow-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #ff88cc;
  box-shadow: 0 0 0 4px rgba(255, 136, 204, 0.18);
  animation: pulse-dot 2.2s ease-in-out infinite;
}
@keyframes pulse-dot {
  0%,
  100% {
    box-shadow: 0 0 0 4px rgba(255, 136, 204, 0.18);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(255, 136, 204, 0.05);
  }
}
.sp-case-quote {
  quotes: "“" "”";
  font-family: "Geist", "Inter", sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: clamp(17px, 1.55vw, 20px);
  line-height: 1.55;
  letter-spacing: -0.005em;
  color: rgba(255, 255, 255, 0.92);
}
.sp-case-quote::before {
  content: open-quote;
  font-size: 1.4em;
  line-height: 0;
  vertical-align: -0.25em;
  margin-right: 0.05em;
  color: rgba(233, 30, 140, 0.5);
}
.sp-case-quote::after {
  content: close-quote;
  font-size: 1.4em;
  line-height: 0;
  vertical-align: -0.25em;
  margin-left: 0.05em;
  color: rgba(233, 30, 140, 0.5);
}

.sp-case-attr {
  padding-top: 18px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-family: var(--sans);
  font-size: 13px;
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.5;
}
.sp-case-attr strong {
  color: #fff;
  display: block;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 2px;
}
.sp-quotes-stack {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.sp-exec-quote {
  padding: 26px 30px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.03);
}
.sp-exec-attr-head {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 18px;
  padding-bottom: 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.sp-exec-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--heading);
  font-style: italic;
  font-size: 18px;
  font-weight: 500;
  color: #fff;
  background: linear-gradient(135deg, rgba(233, 30, 140, 0.5), rgba(107, 47, 160, 0.5));
  border: 1px solid rgba(255, 255, 255, 0.18);
}
.sp-exec-attr-body {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.sp-exec-attr-body strong {
  font-family: var(--sans);
  font-size: 13.5px;
  color: #fff;
  font-weight: 500;
  letter-spacing: -0.005em;
}
.sp-exec-attr-body span {
  font-family: var(--sans);
  font-size: 11px;
  color: rgba(255, 255, 255, 0.55);
  letter-spacing: 0.02em;
}
.sp-exec-quote-text {
  font-family: "Geist", "Inter", sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 14.5px;
  line-height: 1.65;
  letter-spacing: -0.005em;
  color: rgba(255, 255, 255, 0.85);
}
@media (max-width: 900px) {
  .sp-proof-inner {
    grid-template-columns: 1fr;
    gap: 48px;
  }
}

.sp-stack {
  background: var(--bg);
  padding: 100px 0;
}
.sp-stack-header {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  align-items: end;
  margin-bottom: 56px;
}
.sp-stack-header h2 {
  font-family: var(--heading) !important;
  font-size: clamp(30px, 3.2vw, 48px);
  font-weight: 500;
  line-height: 1.08;
  letter-spacing: -0.02em;
  color: var(--ink);
}
.sp-stack-header-right {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-left: 32px;
  border-left: 1px solid var(--border);
}
.sp-stack-header-right p {
  font-family: var(--sans);
  font-size: 15px;
  line-height: 1.6;
  color: rgba(26, 25, 21, 0.7);
}

.sp-stack-labels {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2px;
  margin-bottom: 2px;
}
.sp-stack-label {
  padding: 14px 28px;
  font-family: var(--sans);
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 10px;
}
.sp-stack-label--sierra {
  background: #efede1;
  color: rgba(26, 25, 21, 0.62);
  border-radius: 12px 0 0 0;
  border: 1px solid var(--border);
  border-bottom: none;
}
.sp-stack-label--ibex {
  background: var(--dark);
  color: rgba(255, 255, 255, 0.62);
  border-radius: 0 12px 0 0;
}
.sp-stack-label-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
}
.sp-stack-label--sierra .sp-stack-label-dot {
  background: #6b2fa0;
}
.sp-stack-label--ibex .sp-stack-label-dot {
  background: #e91e8c;
}
.sp-stack-label-meta {
  margin-left: auto;
  font-family: var(--sans);
  font-size: 9.5px;
  font-weight: 500;
  letter-spacing: 0.1em;
  opacity: 0.6;
}

.sp-cap-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2px;
  border-radius: 0 0 14px 14px;
  overflow: hidden;
}
.sp-cap-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2px;
}
.sp-cap-row:last-child .sp-cap-sierra {
  border-radius: 0 0 0 14px;
  border-bottom: 1px solid var(--border);
}
.sp-cap-row:last-child .sp-cap-ibex {
  border-radius: 0 0 14px 0;
}

.sp-cap-sierra {
  background: #efede1;
  padding: 32px 30px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-left: 1px solid var(--border);
  border-right: 1px solid var(--border);
}
.sp-cap-ibex {
  background: var(--dark);
  padding: 32px 30px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-left: 2px solid rgba(233, 30, 140, 0.22);
  position: relative;
}
.sp-cap-ibex::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, rgba(233, 30, 140, 0.4) 50%, transparent 100%);
  opacity: 0.4;
}
.sp-cap-tag {
  font-family: var(--sans);
  font-size: 9.5px;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  padding: 4px 11px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: fit-content;
}
.sp-cap-tag--sierra {
  background: rgba(107, 47, 160, 0.1);
  color: #6b2fa0;
}
.sp-cap-tag--ibex {
  background: rgba(233, 30, 140, 0.18);
  color: #ff88cc;
}

.sp-cap-sierra-name {
  font-family: var(--heading);
  font-size: clamp(18px, 1.55vw, 22px);
  font-weight: 500;
  line-height: 1.18;
  letter-spacing: -0.01em;
  color: var(--ink);
}
.sp-cap-sierra-desc {
  font-family: var(--sans);
  font-size: 13.5px;
  line-height: 1.6;
  color: rgba(26, 25, 21, 0.72);
}
.sp-cap-sierra-bullets {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 4px;
}
.sp-cap-sierra-bullets li {
  font-family: var(--sans);
  font-size: 12.5px;
  line-height: 1.5;
  color: rgba(26, 25, 21, 0.62);
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.sp-cap-sierra-bullets li::before {
  content: "—";
  color: #6b2fa0;
  flex-shrink: 0;
  font-size: 11px;
}

.sp-cap-ibex-name {
  font-family: var(--heading);
  font-size: clamp(18px, 1.55vw, 22px);
  font-weight: 500;
  line-height: 1.18;
  letter-spacing: -0.01em;
  color: #fff;
}
.sp-cap-ibex-desc {
  font-family: var(--sans);
  font-size: 13.5px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.74);
}
.sp-cap-ibex-bullets {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 4px;
}
.sp-cap-ibex-bullets li {
  font-family: var(--sans);
  font-size: 12.5px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.65);
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.sp-cap-ibex-bullets li::before {
  content: "—";
  color: #e91e8c;
  flex-shrink: 0;
  font-size: 11px;
}

@media (max-width: 860px) {
  .sp-stack-header {
    grid-template-columns: 1fr;
  }
  .sp-stack-header-right {
    padding-left: 0;
    border-left: none;
    border-top: 1px solid var(--border);
    padding-top: 20px;
  }
  .sp-stack-labels,
  .sp-cap-row {
    grid-template-columns: 1fr;
  }
  .sp-cap-sierra {
    border-radius: 0 !important;
  }
  .sp-cap-ibex {
    border-left: none;
    border-top: 2px solid rgba(233, 30, 140, 0.18);
  }
  .sp-stack-label--sierra {
    border-radius: 12px 12px 0 0 !important;
  }
  .sp-stack-label--ibex {
    border-radius: 0 !important;
  }
}

.sp-why-ibex {
  background: var(--bg-2);
  padding: 100px 0;
  position: relative;
  overflow: hidden;
}
.sp-why-ibex::before {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(
    ellipse 40% 50% at 100% 0%,
    rgba(233, 30, 140, 0.06) 0%,
    transparent 70%
  );
  pointer-events: none;
}
.sp-why-ibex-header {
  position: relative;
  z-index: 2;
  max-width: 800px;
  margin: 0 auto 64px;
  text-align: center;
}
.sp-why-ibex-header .sp-section-eyebrow {
  justify-content: center;
}
.sp-why-ibex-header h2 {
  font-family: var(--heading) !important;
  font-size: clamp(30px, 3.2vw, 48px);
  font-weight: 500;
  line-height: 1.08;
  letter-spacing: -0.02em;
  color: var(--ink);
  margin-bottom: 18px;
}
.sp-why-ibex-header p {
  font-family: var(--sans);
  font-size: 16px;
  line-height: 1.65;
  color: rgba(26, 25, 21, 0.7);
  max-width: 780px;
  margin: 0 auto;
}

.sp-compare {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 1px;
  background: var(--border);
  border: 1px solid var(--border);
  border-radius: 14px;
  overflow: hidden;
}
.sp-compare-head {
  display: grid;
  grid-template-columns: 1.3fr 1fr 1fr;
  background: #fff;
}
.sp-compare-head > div {
  padding: 18px 24px;
  font-family: var(--sans);
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(26, 25, 21, 0.5);
}
.sp-compare-head .compare-h-mid {
  color: rgba(26, 25, 21, 0.65);
  border-left: 1px solid var(--border);
}
.sp-compare-head .compare-h-ibex {
  color: #c4207a;
  border-left: 1px solid var(--border);
  background: linear-gradient(135deg, rgba(233, 30, 140, 0.04), rgba(107, 47, 160, 0.04));
}
.sp-compare-row {
  display: grid;
  grid-template-columns: 1.3fr 1fr 1fr;
  background: #fff;
}
.sp-compare-row > div {
  padding: 22px 24px;
  font-family: var(--sans);
  font-size: 13.5px;
  line-height: 1.55;
  color: rgba(26, 25, 21, 0.78);
}
.sp-compare-row .compare-label {
  font-family: var(--heading);
  font-size: 16px;
  font-weight: 500;
  color: var(--ink);
  letter-spacing: -0.005em;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.sp-compare-row .compare-label-sub {
  font-family: var(--sans);
  font-size: 11.5px;
  color: rgba(26, 25, 21, 0.55);
  font-weight: 400;
  letter-spacing: 0;
}
.sp-compare-row .compare-mid {
  color: rgba(26, 25, 21, 0.6);
  border-left: 1px solid var(--border);
}
.sp-compare-row .compare-ibex {
  border-left: 1px solid var(--border);
  background: linear-gradient(135deg, rgba(233, 30, 140, 0.04), rgba(107, 47, 160, 0.04));
  color: rgba(26, 25, 21, 0.85);
  font-weight: 500;
}
.sp-compare-row .compare-ibex strong {
  color: #c4207a;
  font-weight: 600;
}
@media (max-width: 860px) {
  .sp-compare-head,
  .sp-compare-row {
    grid-template-columns: 1fr;
  }
  .sp-compare-row > div,
  .sp-compare-head > div {
    border-left: none !important;
    border-top: 1px solid var(--border);
  }
  .sp-compare-head > div:first-child,
  .sp-compare-row > div:first-child {
    border-top: none;
  }
}

.sp-video {
  background: var(--dark);
  padding: 100px 0;
}
.sp-video-card {
  position: relative;
  overflow: hidden;
  border-radius: 24px;
  min-height: 520px;
  display: flex;
  align-items: flex-end;
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.sp-video-card video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
  filter: brightness(0.7) saturate(1.1);
}
.sp-video-card::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 1;
  background:
    linear-gradient(
      180deg,
      rgba(13, 12, 20, 0.1) 0%,
      rgba(13, 12, 20, 0.65) 70%,
      rgba(13, 12, 20, 0.95) 100%
    ),
    linear-gradient(90deg, rgba(13, 12, 20, 0.55) 0%, rgba(13, 12, 20, 0.1) 60%);
  pointer-events: none;
}
.sp-video-content {
  position: relative;
  z-index: 2;
  padding: 56px clamp(28px, 4vw, 64px);
  width: 100%;
  display: grid;
  grid-template-columns: 1.6fr 1fr;
  gap: 48px;
  align-items: end;
}
.sp-video-content h2 {
  font-family: var(--heading) !important;
  font-size: clamp(26px, 2.8vw, 40px);
  font-weight: 500;
  line-height: 1.12;
  letter-spacing: -0.02em;
  color: #fff;
  margin-bottom: 20px;
  max-width: 24ch;
}
.sp-video-content h2 em {
  color: #fff !important;
}
.sp-video-content p {
  font-family: var(--sans);
  font-size: 15px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.78);
  max-width: 46ch;
}
.sp-video-meta {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding-bottom: 6px;
}
.sp-video-stat {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 14px 18px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(8px);
}
.sp-video-stat-num {
  font-family: var(--heading);
  font-size: 26px;
  font-weight: 500;
  color: #fff;
  letter-spacing: -0.01em;
}
.sp-video-stat-label {
  font-family: var(--sans);
  font-size: 11px;
  letter-spacing: 0.04em;
  color: rgba(255, 255, 255, 0.65);
}
@media (max-width: 900px) {
  .sp-video-content {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  .sp-video-card {
    min-height: 480px;
  }
}

.sp-about {
  background: var(--dark-2);
  padding: 100px 0;
  position: relative;
  overflow: hidden;
}

.sp-about-video {
  position: absolute;
  inset: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(0.32) saturate(1.18);
  pointer-events: none;
}

.sp-about::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 1;
  background:
    linear-gradient(
      180deg,
      rgba(19, 18, 28, 0.55) 0%,
      rgba(19, 18, 28, 0.28) 40%,
      rgba(19, 18, 28, 0.55) 100%
    ),
    linear-gradient(90deg, rgba(19, 18, 28, 0) 50%, rgba(19, 18, 28, 0.4) 100%);
  pointer-events: none;
}
.sp-about > .w {
  position: relative;
  z-index: 2;
}
.sp-about-inner {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: start;
}
.sp-about-left h2 {
  font-family: var(--heading) !important;
  font-size: clamp(28px, 3vw, 44px);
  font-weight: 500;
  line-height: 1.1;
  letter-spacing: -0.02em;
  color: #fff;
  margin-bottom: 20px;
  max-width: 22ch;
}
.sp-about-left p {
  font-family: var(--sans);
  font-size: 15.5px;
  line-height: 1.65;
  color: rgba(255, 255, 255, 0.78);
  margin-bottom: 16px;
}
.sp-about-left p strong {
  color: #fff;
  font-weight: 600;
}
.sp-founders {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 20px 22px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.04);
  margin-top: 32px;
}
.sp-founders-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(233, 30, 140, 0.14);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
}
.sp-founders-icon svg {
  width: 22px;
  height: 22px;
  stroke: #ff88cc;
  stroke-width: 1.5;
  fill: none;
}
.sp-founders-text {
  font-family: var(--sans);
  font-size: 13px;
  color: rgba(255, 255, 255, 0.72);
  line-height: 1.55;
}
.sp-founders-text strong {
  color: #fff;
  font-weight: 600;
  display: block;
  margin-bottom: 4px;
  font-size: 13.5px;
}

.sp-brand-eyebrow {
  margin-bottom: 24px;
}
.sp-brand-wall {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  overflow: hidden;
}
.sp-brand-plate {
  background: var(--dark-2);
  padding: 30px 26px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 14px;
  min-height: 130px;
  transition: background 0.2s;
}
.sp-brand-plate:hover {
  background: rgba(255, 255, 255, 0.02);
}
.sp-brand-plate-name {
  font-family: var(--heading);
  font-size: 22px;
  font-weight: 500;
  color: #fff;
  letter-spacing: -0.015em;
  line-height: 1.05;
}
.sp-brand-plate-tag {
  font-family: var(--sans);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.5);
}
.sp-brand-plate--more {
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.sp-brand-plate--more .more-text {
  font-family: var(--heading);
  font-style: italic;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.4);
  line-height: 1.4;
}
@media (max-width: 900px) {
  .sp-about-inner {
    grid-template-columns: 1fr;
    gap: 48px;
  }
}

.sp-faq {
  background: var(--bg);
  padding: 100px 0;
}
.sp-faq-header {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  align-items: end;
  margin-bottom: 48px;
}
.sp-faq-header h2 {
  font-family: var(--heading) !important;
  font-size: clamp(30px, 3.2vw, 48px);
  font-weight: 500;
  line-height: 1.08;
  letter-spacing: -0.02em;
  color: var(--ink);
}
.sp-faq-header-right {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-left: 32px;
  border-left: 1px solid var(--border);
}
.sp-faq-header-right p {
  font-family: var(--sans);
  font-size: 14.5px;
  line-height: 1.6;
  color: rgba(26, 25, 21, 0.65);
}
.sp-faq-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1px;
  background: var(--border);
  border: 1px solid var(--border);
  border-radius: 14px;
  overflow: hidden;
}
.sp-faq-item {
  background: var(--bg);
}
.sp-faq-item summary {
  cursor: pointer;
  list-style: none;
  padding: 24px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  font-family: var(--heading);
  font-size: clamp(14px, 1.2vw, 16px);
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: -0.005em;
  color: var(--ink);
  transition: background 0.2s;
}
.sp-faq-item summary::-webkit-details-marker {
  display: none;
}
.sp-faq-item summary:hover {
  background: rgba(255, 255, 255, 0.6);
}
.sp-faq-item[open] summary {
  background: rgba(255, 255, 255, 0.6);
}
.sp-faq-item .faq-num {
  font-family: var(--sans);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.14em;
  color: #c4207a;
  flex-shrink: 0;
  width: 32px;
}
.sp-faq-item .faq-q {
  flex: 1;
}
.sp-faq-item .faq-chevron {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  transition: transform 0.25s ease;
  color: rgba(26, 25, 21, 0.5);
}
.sp-faq-item[open] .faq-chevron {
  transform: rotate(180deg);
  color: #c4207a;
}
.sp-faq-item .faq-body {
  padding: 20px 28px 28px calc(28px + 32px);
  font-family: var(--sans);
  font-size: 14px;
  line-height: 1.7;
  color: rgba(26, 25, 21, 0.72);
  max-width: 78ch;
}
.sp-faq-item .faq-body p {
  margin-bottom: 12px;
  color: inherit;
  font-size: inherit;
  font-family: var(--sans);
}
.sp-faq-item .faq-body p:last-child {
  margin-bottom: 0;
}
.sp-faq-item .faq-body p strong {
  color: var(--ink);
  font-weight: 600;
  font-family: var(--sans);
}

.sp-cta {
  background: var(--dark);
  padding: 100px 0;
  position: relative;
  overflow: hidden;
}
.sp-cta::before {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(
    ellipse 60% 60% at 50% 100%,
    rgba(233, 30, 140, 0.1) 0%,
    transparent 70%
  );
  pointer-events: none;
}
.sp-cta-inner {
  position: relative;
  z-index: 2;
  max-width: 760px;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
}
.sp-cta h2 {
  font-family: var(--heading) !important;
  font-size: clamp(32px, 3.5vw, 52px);
  font-weight: 500;
  line-height: 1.08;
  letter-spacing: -0.02em;
  color: #fff;
}
.sp-cta p {
  font-family: var(--sans);
  font-size: 17px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.72);
  max-width: 540px;
}
.sp-cta-btns {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  justify-content: center;
}
`;
